import { isUtilityBookingServiceFeeCollection } from './utilityBookingCost.util';

export function getUtilityCollectVoucherLinkLabel(booking: {
  totalCost?: number | null;
  depositAmount?: number | null;
}): string {
  return isUtilityBookingServiceFeeCollection(booking) ? 'Phiếu thu' : 'Phiếu thu cọc';
}

export function getUtilityCollectVoucherModalTitle(booking: {
  totalCost?: number | null;
  depositAmount?: number | null;
}): string {
  return isUtilityBookingServiceFeeCollection(booking) ? 'Phiếu thu' : 'Phiếu thu cọc';
}

export function getUtilityRefundVoucherLinkLabel(): string {
  return 'Phiếu hoàn cọc';
}

export function getUtilityRefundVoucherModalTitle(): string {
  return 'Phiếu hoàn cọc';
}
